'use client';

import dynamic from 'next/dynamic';
import { SkeletonLoader } from '@/shared/ui/skeleton/skeleton';
import { useMenu } from '@/shared/providers/menu-provider';
import { SkeletonLoaderWrapper } from './styles';

const SideMenuSkeleton = () => {
  const { isOpen } = useMenu();

  return (
    <SkeletonLoaderWrapper $isOpen={isOpen}>
      <SkeletonLoader height="100%" width="100%" />
    </SkeletonLoaderWrapper>
  );
};

const SideMenuDynamic = dynamic(
  async () => import('./index').then((module) => module.SideMenu),
  {
    ssr: false,
    loading: () => <SideMenuSkeleton />,
  }
);

export { SideMenuDynamic };
